/**
 * Stacked shadows + inset hairline rings (dark theme).
 */
export const elevation = {
  0: 'none',
  1: '0 0 0 1px rgba(255, 255, 255, 0.08) inset',
  2: '0px 1px 1px rgba(0, 0, 0, 0.4), 0px 2px 2px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.08) inset',
  3: '0px 2px 2px rgba(0, 0, 0, 0.35), 0px 8px 8px -8px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.08) inset',
  4: '0px 2px 2px rgba(0, 0, 0, 0.35), 0px 8px 16px -4px rgba(0, 0, 0, 0.45), 0 0 0 1px rgba(255, 255, 255, 0.08) inset',
  5: '0px 1px 1px rgba(0, 0, 0, 0.3), 0px 8px 16px -4px rgba(0, 0, 0, 0.45), 0px 24px 32px -8px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.1) inset',
};

export function cardElevation(level = 3) {
  return elevation[level] ?? elevation[3];
}
